/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import React, { useContext, useEffect, Suspense } from 'react';
import { AuthContext } from '@xometry/auth-context';
import { Box, Flex, theme, Spinner } from '@xometry/xometry_loft';
import { css } from '@emotion/react';
import RegisterLayout from '../Layout';
import Account from '../../../services/account';
import { WWW_ORIGIN } from '../../../config';
import { lazyWithRetries } from '../../../utils/shimport';
import {
  getPrimaryPartnerId,
  toShopFinancesOnboardingUser,
} from '../../../utils/helpers';

const shopFinancesOnboardingFormLink = `${WWW_ORIGIN}/components/shop-finances-onboarding-form/component.mjs`;
const ShopFinancesOnboardingForm = lazyWithRetries(
  shopFinancesOnboardingFormLink
);

const ShopFinancesRegistration = () => {
  const { isLoading, user } = useContext(AuthContext);

  if (isLoading) {
    return <Spinner />;
  }

  if (!user) {
    window.location.assign('/login');
  }

  useEffect(() => {
    if (window.analytics) window.analytics.page('Link Financial Information');

    const account = new Account();
    async function checkUserStatus() {
      const stripeUserMeta: any = await account.getMe();
      if (
        stripeUserMeta &&
        stripeUserMeta.user &&
        stripeUserMeta.user.card_id
      ) {
        window.location.href = `/account/supplier/onboarding`;
      } else if (
        getPrimaryPartnerId(user) &&
        stripeUserMeta &&
        !stripeUserMeta.user.card_id &&
        stripeUserMeta.user.can_card
      ) {
        window.location.href = '/account/register-xac';
      } else if (!getPrimaryPartnerId(user)) {
        window.location.href = '/account/register-supplier';
      }
    }
    checkUserStatus();
  }, []);

  useEffect(() => {
    /**
     * Redirect to Shop Finances
     */
    const handleStripeRegisterSuccess = () => {
      window.location.href = '/account/supplier/onboarding';
    };

    // Bind the event listener from the imported component form
    document.addEventListener(
      'registerStripeAcctSuccess',
      handleStripeRegisterSuccess
    );
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener(
        'registerStripeAcctSuccess',
        handleStripeRegisterSuccess
      );
    };
  }, []);

  return (
    <RegisterLayout flow="seller" authenticated>
      <Flex
        flexDirection="column"
        width={['350px', '443px']}
        marginBottom={['20px', '60px', '40px']}
      >
        <h1
          css={css`
            color: ${theme.colors.darkBlues[100]};
            font-weight: ${theme.fontWeights.regular};
            font-size: 28px;
            margin-top: 0px;
            margin-bottom: 8px;
            padding-top: 32px;
            text-align: center;
            line-height: ${theme.lineHeights[7]};

            ${theme.mediaQueries.small} {
              font-size: 36px;
              margin-top: initial;
            }
          `}
        >
          Financial Information
        </h1>
        <Box fontSize={theme.fontSizes[2]} textAlign="center" lineHeight="24px">
          Link the bank account that you would like your payments to be sent to.
          All provided information is secure and confidential.
        </Box>
        <Box marginTop="36px" marginBottom="36px" paddingBottom="36px">
          <Suspense fallback={<Spinner />}>
            <ShopFinancesOnboardingForm
              WWW_ORIGIN={WWW_ORIGIN}
              submitButtonText="Continue Registration"
              user={toShopFinancesOnboardingUser(user)}
            />
          </Suspense>
        </Box>
      </Flex>
    </RegisterLayout>
  );
};

export default ShopFinancesRegistration;
